import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article/page";
import ArticleReview from "../pages/article/review/page";
import ArticleShipping from "../pages/article/shipping/page";
import ArticleCoupon from "../pages/article/coupon/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/sugargoo-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/article/sugargoo-review",
    element: <ArticleReview />,
  },
  {
    path: "/article/sugargoo-shipping-guide",
    element: <ArticleShipping />,
  },
  {
    path: "/article/sugargoo-coupon-guide",
    element: <ArticleCoupon />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;